import {
  SwapAssetsDataAndExchangeRateQuery,
  SwapAssetsDataAndExchangeRateQueryNode,
} from '@bts-web/data-layer/server';
import { gqlNetworkFetch } from '@bts-web/utils-relay';

export const getSwapAssetsDataAndExchangeRate = async (props: {
  sourceAssetId: string;
  targetAssetId: string;
}) => {
  const { sourceAssetId, targetAssetId } = props;

  const { data, errors } =
    await gqlNetworkFetch<SwapAssetsDataAndExchangeRateQuery>(
      SwapAssetsDataAndExchangeRateQueryNode.params,
      { sourceAssetId, targetAssetId },
      // we need the exchange rate to always be fresh, so we don't use any cache tags
    );

  if (errors) {
    return { data: undefined, errors };
  }

  if (!data.asset || !data.targetAsset || !data.exchangeRate) {
    return { data: undefined, errors: ['be_internal_error'] };
  }

  return { data, errors: undefined };
};
